import { atom, onMount } from 'nanostores';

export function storedAtom(key: string) {
  const $atom = atom(localStorage.getItem(key));

  onMount($atom, () => {
    const onStorage = () => $atom.set(localStorage.getItem(key));
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  });

  $atom.listen((value) => {
    if (value === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
  });

  return $atom;
}
